import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch } from "react-router-dom";
import { lazy, Suspense } from "react";
import { HashRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import PanelState from "./context/Panel/PanelState";

const App = lazy(() => import('./App'))
const AppLogin = lazy(() => import('./AppLogin'))
const AppResetPassword = lazy(() => import('./AppResetPassword'))
const AppChangePassword = lazy(() => import('./AppChangePassword'))

ReactDOM.render(
    <HashRouter>
        <ScrollToTop>
            <Switch>
                <PanelState>
                    <Suspense fallback={<div>Cargando...</div>}>
                        <Route exact path="/" render={(props) => <AppLogin {...props} />} />
                        <Route exact path="/restablecerPassword" render={(props) => <AppResetPassword {...props} />} />
                        <Route exact path="/cambiarPassword/:token" render={(props) => <AppChangePassword {...props} />} />
                        <Route path="/admin" render={(props) => <App {...props} />} />
                    </Suspense>
                </PanelState>
            </Switch>
        </ScrollToTop>
    </HashRouter>,
    document.getElementById("root")
);
